export function useResetValidation(dataModel, validationViewModel) {

    for(const each in dataModel) {

        if(validationViewModel.hasOwnProperty(each)) {

            validationViewModel[each].value = false;
        }
    }

}
